import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import ChartSectionBordered from "../../../ChartSectionBordered/ChartSectionBordered";
import DashboardInfoTooltip from "../../../DasboardInfoTooltip";
import DetailsButton from "../../../DetailsButton";
import {MENUS} from "../../../../../OtherAssetV2/OtherAssetsModal/constants";
import AmountChip from "../../../AmountChip";
import {BadgeForNew} from "../../../../../../components/Badge";

import styles from "../../styles";


const LiabilitiesCard = (props) => {
  const {
    classes,
    loading,
    error,
    total,
    openModal,
    expanded,
    onExpanded,
  } = props;

  return (
    <ChartSectionBordered
      title={
        <div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <b>Verbindlichkeiten</b>
            <DashboardInfoTooltip
              title={
                'Übersicht über Verbindlichkeiten Ihrer Kunden. Diese können manuell erfasst und bearbeitet werden. ' +
                'Die eingegebenen Werte bleiben unverändert. '
              }
            />
            <BadgeForNew />
          </div>

          <span className={classes.subHeader}>Summe aller Verbindlichkeiten</span>
        </div>
      }
      titleControl={
        <DetailsButton
          onButtonClick={() => openModal(MENUS.liabilities.id)}
          dataId={'liabilities-details-btn'}
          tooltip={'Hier gelangen Sie zur Übersicht der Verbindlichkeiten und können neue hinzufügen sowie bestehende Verbindlichkeiten bearbeiten.'}
        />
      }
      expanded={expanded}
      onExpanded={onExpanded}
      loading={loading}
      error={error}
      displayError
      subSection
      withSubHeader
      content={<AmountChip total={total} withValueClassName={'orange'} />}
    />
  )
};

export default withStyles(styles)(LiabilitiesCard);